export const link = {
    arrow: {
        style: {
            size: 10
        }
    }
};
//# sourceMappingURL=link.js.map
